import React from "react";

import styles from "./index.module.scss";

interface Props {
  hasRule?: boolean;
  label: string;
  setRef?: (elem: HTMLDivElement | null) => void;
}

const HeadlineBlock: React.FC<Props> = ({ hasRule = false, label, setRef }) => {
  return (
    <div
      className={styles.container}
      ref={(ref) => {
        if (setRef) {
          setRef(ref);
        }
      }}
    >
      <h2 className={styles.headline}>{label}</h2>

      {hasRule && <div className={styles.rule} />}
    </div>
  );
};

export { HeadlineBlock };
